import React, { useState, useEffect, useCallback, useRef } from "react";
import { workInProgressStyle as styles } from "./purchaseHistory.tailwind";
import { fetchUserOrders, getUserBuyedPoints } from "../../redux/slices/purchaseHistorySlice";
import { connect, useSelector } from "react-redux";
import DateFilters from "./DateFilters";
import PurchaseTokenListingPage from "./Sections/PurchaseHistory/PurchaseTokenListingPage";
import BuyedPointsListingPage from "./Sections/BuyedPoints/BuyedPointsListingPage";
// import SearchBar from "../shared/Input/SearchBar/SearchBar";
import filter_icon from "../../assets/svgs/filter_icon.svg";
// import SearchIcon from "@mui/icons-material/Search";
// import { ClearIcon } from "@mui/x-date-pickers/icons";

const PurchaseHistory = ({ fetchUserOrders, getUserBuyedPoints }) => {
  const apiRef = useRef(false);
  const { currentSeason } = useSelector(state => state.seasons);

  // Filters
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isFilterApplied, setFilterApplied] = useState(false);
  // State to keep track of the active tab (1 = Purchased Tokens, 2 = Buyed Points)
  const [activeTab, setActiveTab] = useState(1);
  const [isApplyingFilter, setApplyingFilter] = useState(false);
  // const [searchQuery, setSearchQuery] = useState('');
  // const [isSearchApplied, setSearchApplied] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(false);

  // Fetch user orders and buyed points, but only once for the current page
  const callApi = useCallback(async ({ fromDate, toDate }) => {
    if(!currentSeason?._id) return;
    
    const data = {
      page: '1',
      dateFromFilter: fromDate,
      dateToFilter: toDate,
      seasonId: currentSeason?._id
    }

    // Fetch user orders with pagination
    await fetchUserOrders(data);
    await getUserBuyedPoints(data); // Fetch buyed points
    setApplyingFilter(false);
  }, [fetchUserOrders, getUserBuyedPoints, currentSeason?._id]);

  const handleFilter = async () => {
    setFilterApplied(true);
    setApplyingFilter(true);
    
    await callApi({ fromDate, toDate });
  };

  // Clear Filters reset dates to initial state and call API
  const handleClearFilters = async () => {
    setFromDate("");
    setToDate("");

    if (isFilterApplied) {
      callApi({ fromDate: "", toDate: "" });
    }
    setFilterApplied(false);
  };

  // Handle tab change (Purchased Tokens or Buyed Points)
  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };

  useEffect(() => {
    if (apiRef.current) return;
    apiRef.current = true;

    callApi({ fromDate: "", toDate: "", }); // Trigger fetching on component mount or page change
  }, [callApi]);

  useEffect(() => {
    if(currentSeason?._id) {
      callApi({ fromDate, toDate })
    }
  }, [currentSeason?._id]);

  return (
    <div className={styles.outerContainer}>
      {/* Header Section */}
      <div className={styles.header}>
        <span className={styles.heading}>My Purchase History</span>

        {/* Filters Section for small screens*/}
        <div className={styles.filtersOnSmallScreen}>
          {/* {!isSearchApplied &&
            <SearchIcon onClick={() => { setSearchApplied(true); setSelectedFilter(false); }} />
          } */}
          {/* <img src={filter_icon} alt="Filter" onClick={() => { setSelectedFilter(prev => !prev); setSearchApplied(false); }} /> */}
          <img src={filter_icon} alt="Filter" onClick={() => { setSelectedFilter(prev => !prev); }} />

        </div>

        {/* Search Bar For Large Screens
        <div className={styles.filtersForLargeScreens}>
          <SearchBar placeholder="Search" searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
        </div> */}
      </div>

      {/* Filters Section for small screens*/}
      <div className={styles.filters}>
        {/* {isSearchApplied &&
          <div className={styles.searchContainer}>
            <SearchBar
              placeholder="Search"
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
            />
            <ClearIcon onClick={() => setSearchApplied(false)} />
          </div>
        } */}
        {selectedFilter && 
          <DateFilters
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
            handleFilter={handleFilter}
            handleClearFilters={handleClearFilters}
            isApplyingFilter={isApplyingFilter}
            disableFuture={true}
          />
        }
      </div>

      {/* Tab Navigation */}
      <div>
        <div className={styles.historyTabs}>
          <div className={styles.tabContainer} style={{ scrollbarWidth: "none" }}>
            {/* Purchase History */}
            <button onClick={() => handleTabChange(1)} className={`${styles.tab} ${activeTab === 1 ? styles.activeButton : ''}`}>
              <span className={`${styles.tabName}`}>Tokens</span>
              {/* {activeTab === 1 && <div className={styles.activeTab} />} */}
            </button>

            {/* Buyed Points */}
            {/* FOR DEMO */}
            {/* <button onClick={() => handleTabChange(2)} className={`${styles.tab} ${activeTab === 2 ? styles.activeButton : ''}`}> */}
              {/* <span className={`${styles.tabName}`}>Points</span> */}
              {/* {activeTab === 2 && <div className={styles.activeTab} />} */}
            {/* </button> */}
          </div>
          <div className={styles.filtersForLargeScreens}>
            <DateFilters
              fromDate={fromDate}
              toDate={toDate}
              setFromDate={setFromDate}
              setToDate={setToDate}
              handleFilter={handleFilter}
              handleClearFilters={handleClearFilters}
              isApplyingFilter={isApplyingFilter}
              disableFuture={true}
            />
          </div>
        </div>

        {/* Divider Line */}
        <div className={styles.divider}></div>
      </div>

      {/* Conditional Rendering of Components Based on Active Tab */}
      <>
        {/* for tab 1 */}
        {activeTab === 1 && <PurchaseTokenListingPage fromDate={fromDate} toDate={toDate} />}

        {/* for tab 2 */}
        {activeTab === 2 && <BuyedPointsListingPage fromDate={fromDate} toDate={toDate} />}
      </>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  fetchUserOrders: (data) => dispatch(fetchUserOrders(data)), // Dispatch action to fetch orders with pagination
  getUserBuyedPoints: (data) => dispatch(getUserBuyedPoints(data)), // Dispatch action to fetch buyed points
});

export default connect(null, mapDispatchToProps)(PurchaseHistory);
